// extracted by css-extract-rspack-plugin
export default {"selectIcon":"selectIcon-PMq9nj"};